import React, { useEffect } from "react";
import "./indicadores.css";

const Indicadores = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container indicadores-container">
      <div className='row '>
            <div className='col_12'>
                <div className='indicadores_title '>
                    <h1>Indicadores</h1>
                </div>
            </div>
        </div>
      
      <hr className="hr-gob" />
      
      <div className='row'>
               
                  <div className='col-md-4 text-center'>
                    <div className="card">
                    <div className="card-body">
                    <div className='row'>
                    <h1 className="cantidad">120,641</h1>
                    <p className="tipo-indicador">Productores en Apoyos recibidos</p>
                    </div>
                    <div className='row'>
                    <img className="img-indicador" src="./img/indicadores/granjero.png"></img>
                    </div>
                  </div>
                  </div>
                  </div>
                  
                  <div className='col-md-4 text-center'>
                  <div className="card">
                      <div className="card-body">
                      <div className='row'>
                    <h1 className="cantidad">880</h1>
                    <p className="tipo-indicador">Créditos por Gestiones</p>
                    </div>
                    <div className='row'>
                    <img className="img-indicador" src="./img/indicadores/banco.png"></img>
                    </div>
                  </div>
                  </div>
                  </div>
          
                  <div className='col-md-4 text-center'>
                  <div className="card">
                      <div className="card-body">
                      <div className='row'>
                    <h1 className="cantidad"> 3,160,040</h1>
                    <p className="tipo-indicador">Árboles y Especies producidos en viveros</p>
                    </div>
                    <div className='row'>
                    <img className="img-indicador" src="./img/indicadores/agricultura.png"></img>
                    </div>
                  </div>
                  </div>
                   </div>

                  <div className='col-md-4 text-center'>
                  <div className="card">
                      <div className="card-body">
                      <div className='row'>
                    <h1 className="cantidad">5,600,000</h1>
                    <p className="tipo-indicador">Crías de Peces</p>
                    </div>
                    <div className='row'>
                    <img className="img-indicador" src="./img/indicadores/cria-de-peces.png"></img>
                    </div>
                  </div>
                  </div>
                   </div>
                  
                  <div className='col-md-4 text-center '>
                  <div className="card">
                      <div className="card-body">
                      <div className='row'>
                    <h1 className="cantidad">47,563</h1>
                    <p className="tipo-indicador">Hectáreas Comercializadas</p>
                   </div>
                    <div className='row'>
                    <img className="img-indicador" src="./img/indicadores/semillas.png"></img>
                    </div>
                  </div>
                  </div>
                   </div>

                </div>
            </div>
        
  );
};

export default Indicadores;
